// @flow

import React from 'react';
import {Icon} from '@xsolla/uikit';
import classNames from 'classnames/bind';
import Spinner from '../spinner';
import style from './style.css';

type Props = {
  +disabled?: boolean,
  +fetching?: boolean,
  +icon?: string,
  +children: string
};

const cx = classNames.bind(style);

const Button = (props: Props) => {
  const {disabled = true, fetching = false, icon, children, ...other} = props;

  return (
    <div
      className={cx(
        'disputes-button',
        disabled ? 'disputes-button--disabled' : 'disputes-button--enable'
      )}
      {...other}>
      {fetching ? <Spinner size="sm" /> : <Icon name={icon} />}
      <span className={cx('disputes-button__title')}>{children}</span>
    </div>
  );
};

export default Button;
